import { render, staticRenderFns } from "./BibleCloudChapter.vue?vue&type=template&id=39eff37d&scoped=true&"
import script from "./BibleCloudChapter.vue?vue&type=script&lang=js&"
export * from "./BibleCloudChapter.vue?vue&type=script&lang=js&"
import style0 from "./BibleCloudChapter.vue?vue&type=style&index=0&id=39eff37d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eff37d",
  null
  
)

export default component.exports